// Shared, lightweight version-label detection (display only) — mirrors backend classify_version_labels.
const norm = (s) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const RULES = [
  ["TONO BAJO", ["tono bajo", "lower key"]],
  ["TONO ALTO", ["tono alto", "higher key"]],
  ["MUJER", ["para mujer", "female key", "mujer"]],
  ["HOMBRE", ["para hombre", "male key", "hombre"]],
  ["PIANO", ["piano"]],
  ["ACÚSTICO", ["acustico", "acoustic"]],
];

export const classifyVersionLabels = (text) => {
  const nt = norm(text);
  if (!nt) return [];
  const padded = ` ${nt} `;
  const out = [];
  for (const [label, variants] of RULES) {
    if (variants.some((v) => padded.includes(` ${v} `) || nt === v)) out.push(label);
  }
  return out;
};

export const isCarpool = (text) => norm(text).includes("carpool karaoke");

// Tailwind classes per label (kept subtle, matches the app's neon aesthetic)
export const LABEL_STYLE = {
  "TONO BAJO": "text-blue-300 bg-blue-400/10 border-blue-400/30",
  "TONO ALTO": "text-sky-300 bg-sky-400/10 border-sky-400/30",
  MUJER: "text-pink-300 bg-pink-400/10 border-pink-400/30",
  HOMBRE: "text-cyan-300 bg-cyan-400/10 border-cyan-400/30",
  PIANO: "text-violet-300 bg-violet-400/10 border-violet-400/30",
  "ACÚSTICO": "text-amber-300 bg-amber-400/10 border-amber-400/30",
  EXPLÍCITA: "text-red-300 bg-red-500/10 border-red-500/40",
  "NO RECOMENDADA": "text-orange-300 bg-orange-500/10 border-orange-500/40",
  REVISAR: "text-yellow-300 bg-yellow-500/10 border-yellow-500/40",
};

export const CONTENT_LABELS = ["EXPLÍCITA", "NO RECOMENDADA", "REVISAR"];
